
import Block 	from 'Mixins/Block';

export default Block('component-select-box', {
	fn: {
		clickHandler (e) {
			e.preventDefault();
			const parent = this.parentNode;
			const list = parent.querySelector('[data-list]');
			list.classList.toggle('active');
			this.classList.toggle('active');
			// console.log('click', list);
		}
	},
	onLoad (block) {
		const _this = this;
		block.forEach((node) => {
			const handler = node.querySelector('[data-trigger]');
			handler.addEventListener('click', _this.fn.clickHandler);
		});
	}

});
